define(
	'Tavanoteam.TavanoTeam_Footer_Extension.Footer'
	, []
	, function () {
		'use strict';
		return {
			mountToApp: function mountToApp(container) {
				var environment = container.getComponent("Environment");
				var layout = container.getComponent('Layout');
				var checkout = container.getComponent('Checkout');
				var configColumns = environment.getConfig('tavanoTeamFooterExtension.columns');
				var followUsColumn = configColumns.columnFollowUs;
				var newsletterColumn = configColumns.columnNewsLetter;
				// Follow Us Settings
				if (followUsColumn.links.length > 0) {
					var iconStyle = followUsColumn.iconsStyle === "Square" ? "-square" : "";
					iconStyle = followUsColumn.iconsStyle === "Rounded" ? "-rounded" : iconStyle;
					// Follow Us Settings
					for (var i = 0; i < followUsColumn.links.length; i++) {
						if (followUsColumn.linksDisplay === "Icon and Label") {
							followUsColumn.links[i].linkClass = "footer-ext-link-social-icon-label";
						}
						if (followUsColumn.linksDisplay === "Icon and Label" || followUsColumn.linksDisplay === "Only Icon") {
							followUsColumn.links[i].icon = "footer-ext-icon-" + followUsColumn.links[i].media.toLowerCase() + iconStyle;
							followUsColumn.links[i].icon = followUsColumn.links[i].icon.replace(" ", "-");
							if (!!followUsColumn.links[i].custom) {
								followUsColumn.links[i].icon = "footer-ext-icon-custom" + iconStyle + " " + followUsColumn.links[i].custom;
							}
							followUsColumn.links[i].iconRounded = (followUsColumn.iconsStyle === "Rounded");
						}
						if (followUsColumn.linksDisplay === "Icon and Label" || followUsColumn.linksDisplay === "Only Label") {
							followUsColumn.links[i].text = followUsColumn.links[i].label;
						}
						if (followUsColumn.linksDisplay === "Only Icon") {
							followUsColumn.links[i].linkClass = "footer-ext-link-social-icon";
							followUsColumn.links[i].media = false;
						}
					}
				}
				// NewsLetter Settings
				newsletterColumn.newsletter = true;
				// Concat all columns
				var columns = [];
				columns = columns.concat(configColumns.column01, configColumns.column02, configColumns.column03, configColumns.column04, configColumns.column05, configColumns.column06, newsletterColumn);
				// Follow Us Self Column checker
				if (!!followUsColumn.mergeWith === false ||
					(followUsColumn.mergeWith != configColumns.column01.id &&
					followUsColumn.mergeWith != configColumns.column02.id &&
					followUsColumn.mergeWith != configColumns.column03.id &&
					followUsColumn.mergeWith != configColumns.column04.id &&
					followUsColumn.mergeWith != configColumns.column05.id &&
					followUsColumn.mergeWith != configColumns.column06.id &&
					followUsColumn.mergeWith != newsletterColumn.id)) {
					followUsColumn.selfColumn = true;
					followUsColumn.id = followUsColumn.mergeWith;
					columns = columns.concat(followUsColumn);
				}
				// Configure Columns & Links
				var getColumnWidth = function (columnWidth) {
					switch (columnWidth) {
						case 'Small (col-2)':
							columnWidth = 'footer-content-small';
							break;
						case 'Medium (col-3)':
							columnWidth = 'footer-content-medium';
							break;
						case 'Large (col-4)':
							columnWidth = 'footer-content-large';
							break;
						case 'Half (col-6)':
							columnWidth = 'footer-content-half';
							break;
						default:
							columnWidth = 'footer-content-full';
					}
					return columnWidth;
				}
				var footerColumns = [];
				for (var i = 0; i < columns.length; i++) {
					if (columns[i].displayDesktop || columns[i].displayMobile) {
						// Icon links in Custom Columns
						if (columns[i].id === followUsColumn.mergeWith && !!followUsColumn.selfColumn === false) {
							if (columns[i].newsletter) {
								columns[i].links = followUsColumn.links;
							} else {
								columns[i].links = columns[i].links.concat(followUsColumn.links);
							}
						}
						if (!!columns[i].links) {
							for (var j = 0; j < columns[i].links.length; j++) {
								// Links Types
								if (columns[i].links[j].linkType === "text") {
									columns[i].links[j].link = false;
								}
								if (columns[i].links[j].linkType === "phone") {
									columns[i].links[j].icon = "footer-ext-icon-phone";
									columns[i].links[j].link = "tel:" + columns[i].links[j].link;
									columns[i].links[j].touchpoint = false;
									columns[i].links[j].hashtag = false;
								}
								if (columns[i].links[j].linkType === "mail") {
									columns[i].links[j].icon = "footer-ext-icon-mail";
									columns[i].links[j].link = "mailto:" + columns[i].links[j].link;
									columns[i].links[j].touchpoint = false;
									columns[i].links[j].hashtag = false;
								}
								// Links Class
								if (!columns[i].links[j].linkClass) {
									columns[i].links[j].linkClass = "";
								}
								if (!!columns[i].links[j].italic) {
									columns[i].links[j].linkClass += " footer-ext-link-italic";
								}
								if (!!columns[i].links[j].additionalClass) {
									columns[i].links[j].linkClass += " " + columns[i].links[j].additionalClass;
								}
							}
							// Reorder links by order field
							if (columns[i].links.length > 0) {
								columns[i].links.sort(function (a, b) {
									a.order = !!a.order ? a.order : columns[i].links.length;
									b.order = !!b.order ? b.order : columns[i].links.length;
									return a.order - b.order;
								});
							}
						}
						columns[i].displayDesktop = !!columns[i].displayDesktop ? "footer-content-desktop" : "";
						columns[i].displayMobile = !!columns[i].displayMobile ? "footer-content-mobile" : "";
						columns[i].desktopWidth = getColumnWidth(columns[i].desktopWidth) + "-desktop";
						columns[i].tabletWidth = getColumnWidth(columns[i].tabletWidth) + "-tablet";
						columns[i].mobileWidth = getColumnWidth(columns[i].mobileWidth) + "-mobile";
						columns[i].desktopPosition = "footer-content-order-desktop-" + columns[i].desktopPosition;
						columns[i].mobilePosition = "footer-content-order-mobile-" + columns[i].mobilePosition;
						columns[i].class = columns[i].displayDesktop + " " + columns[i].displayMobile;
						columns[i].class += " " + columns[i].desktopWidth + " " + columns[i].tabletWidth + " " + columns[i].mobileWidth;
						columns[i].class += " " + columns[i].desktopPosition + " " + columns[i].mobilePosition;
						if (!!columns[i].additionalClass) {
							columns[i].class += " " + columns[i].additionalClass;
						}
						footerColumns.push(
							{
								id: columns[i].id,
								title: columns[i].title,
								description: !!columns[i].description ? columns[i].description : false,
								class: columns[i].class,
								links: columns[i].links,
								newsletter: !!columns[i].newsletter,
								collapsible: columns[i].collapsible
							}
						);
					}
				}
				// Bottom Section: Copyright text
				var bottomSection = environment.getConfig('tavanoTeamFooterExtension.bottomSection');
				var copyright = bottomSection.copyright;
				copyright = copyright.replace("[[date]]", new Date().getFullYear());
				layout.addToViewContextDefinition('Footer.View', 'ttFooterExtension', 'array', function () {
					return {
						bottomFooter: bottomSection.enabled,
						copyright: copyright,
						copyrightTopHTML: bottomSection.topHTML,
						copyrightBottomHTML: bottomSection.bottomHTML,
						copyrightAlignment: !!bottomSection.copyrightAlignment ? "footer-content-bottom-copyright-align-" + bottomSection.copyrightAlignment.toLowerCase() : false,
						copyrightLinks: bottomSection.links.length > 0 ? bottomSection.links : false,
						payments: bottomSection.payments,
						columns: footerColumns
					}
				});
				if (checkout) {
					layout.addToViewContextDefinition('Footer.Simplified.View', 'ttFooterExtension', 'array', function () {
						return {
							bottomFooter: bottomSection.checkoutEnabled,
							copyright: copyright,
							payments: bottomSection.payments
						}
					});
				}
			}
		};
	}
);
